import userflow from 'userflow.js';
import { gaEventUSER } from './gaEvent';
import { MPEvents } from './mixpanel/types';
import { mpEvent } from './mixpanel/useMixPanel';
import { clearTokenService } from './tokenService';
import { captureException, getCurrentScope } from '@sentry/react';

// Keep for deep link preservation (still needed)
export const LSKEY_INITIAL_URL = '__cydea_initial_url__';
/** @deprecated Use LSKEY_INITIAL_URL instead (typo fix) */
export const LSKEY_INITAIL_URL = LSKEY_INITIAL_URL;

export const auth0Domain: string = process.env.AUTH0_DOMAIN!;
export const auth0ClientID: string = process.env.AUTH0_CLIENT_ID!;
export const auth0Audience: string = process.env.AUTH0_AUDIENCE!;

type MakeLogout = (params?: { noEvents?: boolean }) => void;

export const makeLogout: MakeLogout = (params) => {
  if (!params?.noEvents) {
    gaEventUSER('LOGOUT');
    mpEvent(MPEvents.Logout, { tags: ['USER'] });
  }
  clearTokenService();
  try {
    userflow.reset();
  } catch (error) {
    captureException(error);
  }
  // Clear the Sentry scope (user, tags, context) so any error fired after logout or
  // during a tenant switch is not mis-attributed to the previous user/workspace/org.
  getCurrentScope().clear();
  window.location.href = '/';
};

/**
 * Get user initials from name for avatar display.
 */
export const getProfileCredentials = (name: string | undefined): string => {
  let credentials = '';
  if (name) {
    const cleanName = name.replace(/\s*\(You\)$/, '');
    const splits = cleanName.split(' ');
    splits.forEach((s) => {
      if (credentials.length < 2 && s.length > 0) {
        credentials += s[0];
      }
    });
  }
  return credentials;
};
